export const DASHBOARD_CHART_COLORS = [
  '#FF9AA2',
  '#0069d0',
  '#f59e0b',
  '#B5EAD7',
  '#C7CEEA'
];

export const DASHBOARD_CHART_NEUTRAL = '#e5e7eb';

export const DASHBOARD_VISIBILITY_STORAGE_KEY = 'dashboard-visibility-states';
